import { swimLaneData, swimLaneOwners, ownerStyles } from '../data'

export function SwimLaneView() {
  return (
    <div className="space-y-4">
      <p className="text-xs text-[var(--text-muted)]">
        Each column shows what that role is responsible for at each phase of the process.
      </p>

      <div className="overflow-x-auto rounded-xl border border-[var(--border-color)]">
        <table className="w-full min-w-[800px]">
          <thead>
            <tr className="bg-[var(--bg-secondary)]">
              <th className="text-left text-xs font-semibold text-[var(--text-primary)] px-4 py-3 border-b border-[var(--border-color)] w-[140px]">
                Phase
              </th>
              {swimLaneOwners.map((owner) => {
                const style = ownerStyles[owner]
                return (
                  <th
                    key={owner}
                    className="text-left text-xs font-semibold px-4 py-3 border-b border-l border-[var(--border-color)]"
                  >
                    <div className="flex items-center gap-1.5">
                      <div className={`w-2.5 h-2.5 rounded-full ${style.dot}`} />
                      <span className={style.text}>{style.label}</span>
                    </div>
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody>
            {swimLaneData.map((row, i) => (
              <tr
                key={row.phase}
                className={i % 2 === 0 ? 'bg-[var(--bg-primary)]' : 'bg-[var(--bg-secondary)]/50'}
              >
                <td className="px-4 py-3 border-b border-[var(--border-color)] align-top">
                  <span className="text-xs font-semibold text-[var(--text-primary)]">{row.phase}</span>
                </td>
                {swimLaneOwners.map((owner) => {
                  const cellText = row[owner]
                  const style = ownerStyles[owner]
                  return (
                    <td
                      key={owner}
                      className="px-4 py-3 border-b border-l border-[var(--border-color)] align-top"
                    >
                      {cellText ? (
                        <div className={`text-xs leading-relaxed rounded-lg px-2.5 py-2 ${style.bg} ${style.text}`}>
                          {cellText}
                        </div>
                      ) : (
                        <span className="text-xs text-[var(--text-muted)]/30">-</span>
                      )}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
